/**
 * Kľúče pre `t()` – rovnaký výsledný text ako backend `documentTitle` (HTML tlač / ExportExcelNaming):
 * po `t(kľúč)` → názov hárka v XLSX (max 31 znakov) + predvolený názov súboru pri exporte.
 */
export const EXPORT_DOCUMENT_TITLE_KEYS = Object.freeze({
  SERVICE_TASK_MY_AGENDA: 'Export.DocumentTitle.ServiceTaskMyAgenda',
  SERVICE_TASK_FULL_LIST: 'Export.DocumentTitle.ServiceTaskFullList',
  TASK_TEMPLATES: 'Export.DocumentTitle.TaskTemplates',
  SERVICE_STATES: 'Export.DocumentTitle.ServiceStates',
  DEPARTMENTS: 'Export.DocumentTitle.Departments',
  MACHINES: 'Export.DocumentTitle.Machines',
  CHECKLIST_HOLIDAYS: 'Export.DocumentTitle.ChecklistHolidays',
  EMPLOYEES: 'Export.DocumentTitle.Employees',
  USERS: 'Export.DocumentTitle.Users',
  ROLES: 'Export.DocumentTitle.Roles',
  MACHINE_TYPES: 'Export.DocumentTitle.MachineTypes',
  LECTURERS: 'Export.DocumentTitle.Lecturers',
  TRAINING_INVITATION_TEMPLATES: 'Export.DocumentTitle.TrainingInvitationTemplates',
  TRAINING_TYPES: 'Export.DocumentTitle.TrainingTypes',
  CHECKLIST_TEMPLATES: 'Export.DocumentTitle.ChecklistTemplates',
  BUSINESS_PARTNERS: 'Export.DocumentTitle.BusinessPartners',
  CUSTOMER_BUSINESS_DATA_OTK: 'Export.DocumentTitle.CustomerBusinessDataOtk',
  /** Základ pre predvolený názov súboru; backend môže vrátiť presný titul s názvom firmy v Content-Disposition. */
  COMPANY_STATISTICS_MONTHLY: 'Export.DocumentTitle.CompanyStatisticsMonthly',
  /** Agregovaný zoznam období (gset020); zhodné s backend CompanyStatisticController::EXPORT_PERIODS_DOCUMENT_TITLE. */
  OTK_STATISTICS_BY_PERIOD: 'Export.DocumentTitle.OtkStatisticsByPeriod',
  SUPPORT_TICKET_LIST: 'Export.DocumentTitle.SupportTicketList',
  CRM_LEVELS: 'Export.DocumentTitle.CrmLevels',
  CRM_STATES: 'Export.DocumentTitle.CrmStates',
  CRM_STEPS: 'Export.DocumentTitle.CrmSteps',
  CRM_TRADERS: 'Export.DocumentTitle.CrmTraders',
  CRM_CENTRAL_DB: 'Export.DocumentTitle.CrmCentralDatabase',
  CRM_COMMUNICATION_MY_AGENDA: 'Export.DocumentTitle.CrmCommunicationMyAgenda',
  CRM_COMMUNICATION_FULL_LIST: 'Export.DocumentTitle.CrmCommunicationFullList',
  ERROR_RECORDS_INT: 'Export.DocumentTitle.ErrorRecordsInt',
  ERROR_RECORDS_EXT: 'Export.DocumentTitle.ErrorRecordsExt',
  ERROR_RECORDS_REK: 'Export.DocumentTitle.ErrorRecordsRek',
  CALIBRATION_COMPANIES: 'Export.DocumentTitle.CalibrationCompanies',
  CALIBRATION_COMPANY_CERT_STATE: 'Export.DocumentTitle.CalibrationCompanyCertState',
  MEASURE_DOCUMENTATION: 'Export.DocumentTitle.MeasureDocumentation',
  MEASURE_MEASUREMENT_PROTOCOL: 'Export.DocumentTitle.MeasureMeasurementProtocol',
  MEASURE_SELF_CONTROL: 'Export.DocumentTitle.MeasureSelfControl',
  MEASURE_NDT_PROTOCOL: 'Export.DocumentTitle.MeasureNdtProtocol',
  MEASURE_ANNEALING_PROTOCOL: 'Export.DocumentTitle.MeasureAnnealingProtocol',
});

/**
 * @deprecated Rovnaké ako {@link EXPORT_DOCUMENT_TITLE_KEYS}. Používaj výhradne
 * `EXPORT_DOCUMENT_TITLE_KEYS` + `t()` v novom kóde; alias ostáva kvôli starým vetvám / ESLint.
 */
export const EXPORT_DOCUMENT_TITLES = EXPORT_DOCUMENT_TITLE_KEYS;

/** Zodpovedá backend ExportExcelNaming::sheetTitle */
export function excelSheetTitleFromDocumentTitle(title) {
  return String(title || '').replace(/[\\/*[\]:?]/g, '').slice(0, 31);
}

/** Zodpovedá backend ExportExcelNaming::downloadFilename */
export function xlsxDownloadFilename(documentTitle) {
  const base = String(documentTitle || '').trim().replace(/[\\/:*?"<>|]+/g, '-');
  return `${base}.xlsx`;
}
